var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{attrs:{"show":_vm.loading}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"block",staticStyle:{"text-align":"center"}},_vm._l((_vm.tips),function(tip){return _c('div',{key:tip.key},[_vm._v("\n        "+_vm._s(tip.name)+"\n      ")])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d769291","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/init.vue
// module id = null
// module chunks = 